import { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default marker icon
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

interface MapPickerProps {
  latitude?: number;
  longitude?: number;
  onLocationSelect: (lat: number, lng: number) => void;
  className?: string;
}

// Component to handle map clicks
function LocationMarker({ position, onLocationSelect }: {
  position: [number, number] | null;
  onLocationSelect: (lat: number, lng: number) => void;
}) {
  useMapEvents({
    click(e) {
      onLocationSelect(e.latlng.lat, e.latlng.lng);
    },
  });

  return position === null ? null : (
    <Marker position={position} />
  );
}

export function MapPicker({
  latitude,
  longitude,
  onLocationSelect,
  className = '',
}: MapPickerProps) {
  // Default center: Thailand (Bangkok)
  const defaultCenter: [number, number] = [13.7563, 100.5018];

  const [position, setPosition] = useState<[number, number] | null>(
    latitude && longitude ? [latitude, longitude] : null
  );

  const [center, setCenter] = useState<[number, number]>(
    latitude && longitude ? [latitude, longitude] : defaultCenter
  );

  useEffect(() => {
    if (latitude && longitude) {
      setPosition([latitude, longitude]);
      setCenter([latitude, longitude]);
    }
  }, [latitude, longitude]);

  const handleLocationSelect = (lat: number, lng: number) => {
    setPosition([lat, lng]);
    onLocationSelect(lat, lng);
  };

  return (
    <div className={`relative ${className}`}>
      <MapContainer
        center={center}
        zoom={latitude && longitude ? 13 : 6}
        scrollWheelZoom={true}
        style={{ height: '100%', width: '100%', borderRadius: '0.5rem' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <LocationMarker position={position} onLocationSelect={handleLocationSelect} />
      </MapContainer>

      {/* Instructions */}
      <div className="absolute top-4 left-4 bg-white px-4 py-2 rounded-lg shadow-md z-[1000] text-sm">
        <p className="font-medium text-gray-700">คลิกบนแผนที่เพื่อเลือกตำแหน่ง</p>
        {position && (
          <p className="text-xs text-gray-500 mt-1">
            Lat: {position[0].toFixed(6)}, Lng: {position[1].toFixed(6)}
          </p>
        )}
      </div>
    </div>
  );
}

export default MapPicker;
